import {gsap} from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import $ from "jquery";

class Zugang {
  init() {
    this.initPage();
    this.initParallax();
  }

  initPage = () => {
    $('.zugang_header').addClass('show');
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header_background');
    customAnmation.scaleBgImage('.intro_background', '.intro');

    customAnmation.animateTextGroup('.content_text');
  }
}

export default Zugang;
